import { ClubList } from '@/components/clubs/ClubList';
import { Button } from '@/components/ui/button';
import { FieldHelp, useAutoStartTour } from '@/features/guided-help';
import { useAuth } from '@/hooks/useAuth';
import { Building2, Plus } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Clubs: React.FC = () => {
  const navigate = useNavigate();
  const { hasOwnerRole, isFutureOwner } = useAuth();

  useAutoStartTour('panel.clubs');

  const handleNavigateToCreateClub = () => {
    navigate('/clubs/create');
  };

  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-[26px] flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        {/* Left: icon box + text */}
        <div className="flex items-start gap-3">
          <div className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-[11px] bg-gc-navySoft text-gc-navy">
            <Building2 size={22} />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h2 className="text-[23px] font-bold tracking-[-0.4px] text-gc-ink">
                Gestión de Clubes
              </h2>
              <FieldHelp topicId="panel.clubs.list" />
            </div>
            <p className="mt-1 text-[13.5px] text-gc-muted">
              Administrá tus clubes propios y aquellos donde tenés permisos de
              manager o profesor.
            </p>
          </div>
        </div>

        {/* Right: new club button (owner or future owner registering first club) */}
        {(hasOwnerRole || isFutureOwner) && (
          <Button
            onClick={handleNavigateToCreateClub}
            className="flex w-fit items-center gap-2"
          >
            <Plus size={18} />
            Nuevo club
          </Button>
        )}
      </div>

      <div data-guide-id="panel.clubs.list">
        <ClubList />
      </div>
    </div>
  );
};

export default Clubs;
